var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/editors/x-buildify-inline-editor.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/dialog/x-drawer-panel.js";
import { html, nothing } from "lit";
import { customElement, state } from "lit/decorators.js";
import { createRef, ref } from "lit/directives/ref.js";
import "../components/x-buildify-size-picker.js";
import { EditContentConsumer, SizeBreakpointConsumer } from "../globals/consumer.js";
import { ThrowEventSetEditContent } from "../globals/events.js";
import "./../x-buildify-toolbar.js";
var XBuildifyInlineEditor = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this._consumedSizeBreakpoints = SizeBreakpointConsumer(this);
    this._drawer = createRef();
    this._size = new RXController(this, void 0);
    this._consumedEditContent = EditContentConsumer(this);
    this._avoidFurtherActionOnDrawerClose = false;
  }
  update(changedProperties) {
    super.update(changedProperties);
    const drawer = this._drawer.value;
    if (!drawer)
      return;
    const isOpened = drawer.isOpen;
    if (this._consumedEditContent.value && !isOpened) {
      drawer.open();
      return;
    }
    if (!this._consumedEditContent.value && isOpened) {
      drawer.close();
      return;
    }
  }
  render() {
    return xComponents(html`
      <x-flex space="md">
        <x-buildify-toolbar
          @size-changed=${(e) => {
      this._size.next(e.detail.value);
    }}
        >
        </x-buildify-toolbar>

        <!-- buildify visualization -->
        <x-flex
          ${css({
      width: this._size.value && this._consumedSizeBreakpoints.value ? `${this._consumedSizeBreakpoints.value[this._size.value]}px` : "100%",
      alignSelf: "center"
    })}
        >
          <slot></slot>
        </x-flex>
      </x-flex>

      <x-drawer-panel
        ${ref(this._drawer)}
        @close=${() => {
      if (this._avoidFurtherActionOnDrawerClose)
        return this._avoidFurtherActionOnDrawerClose = false;
      ThrowEventSetEditContent(this, null);
    }}
      >
        <!-- using invisible input to grab focus so that no dropdown automatically opens -->
        <input type="text" tabindex="-1" ${css({ opacity: "0", height: "1px" })} />
        <x-flex padding="md" ${css({ width: "min(600px, 100vw)", height: "100%" })}>
          ${this._consumedEditContent.value ? html` <x-extension-editor .content=${this._consumedEditContent.value}></x-extension-editor> ` : nothing}
        </x-flex>
      </x-drawer-panel>
    `);
  }
};
__decorateClass([
  state()
], XBuildifyInlineEditor.prototype, "_consumedSizeBreakpoints", 2);
__decorateClass([
  state()
], XBuildifyInlineEditor.prototype, "_drawer", 2);
__decorateClass([
  state()
], XBuildifyInlineEditor.prototype, "_size", 2);
XBuildifyInlineEditor = __decorateClass([
  customElement("x-buildify-inline-editor")
], XBuildifyInlineEditor);
export {
  XBuildifyInlineEditor
};
